module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 109.37 109.37"><title>icon-x</title><g data-name="Layer 2"><path d="M68.83 54.69l37.61-37.61A10 10 0 0 0 92.3 2.93L54.69 40.54 17.07 2.93A10 10 0 0 0 2.93 17.07l37.61 37.62L2.93 92.3a10 10 0 0 0 14.14 14.14l37.62-37.61 37.61 37.61a10 10 0 1 0 14.14-14.14z" data-name="Layer 1"/></g></svg>'};


//////////////////
// WEBPACK FOOTER
// ./source/images/icon-x.svg
// module id = 8
// module chunks = 1